export enum AuditMode {
    Off = 'Off',
    DiffOnly = 'DiffOnly',
    Full = 'Full',
}
